/**
 * Router-shell de /pedidos.
 */
import React from "react";
import { Route, Routes } from "react-router-dom";

import PedidoDetalhe from "./Detalhe";
import PedidosLista from "./Lista";

export default function Pedidos() {
  return (
    <Routes>
      <Route index element={<PedidosLista />} />
      <Route path=":pedidoId" element={<PedidoDetalhe />} />
    </Routes>
  );
}
